import { render } from "./Neolinkdjib.vue?vue&type=template&id=096513e6"
import script from "./Neolinkdjib.vue?vue&type=script&lang=js"
export * from "./Neolinkdjib.vue?vue&type=script&lang=js"

import "./Neolinkdjib.vue?vue&type=style&index=0&id=096513e6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__